export default function useClipboard() {
    const writeText = (text: string): void => {
        // Modern browsers
        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(text);
            return;
        }

        // Legacy browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
    };

    const clear = (): void => {
        writeText('');
    };

    return { writeText, clear };
}
